import React from 'react';
import OptionMsrpHeader from './OptionMsrpHeader';
import OptionCheckbox from './OptionCheckbox';
import MarketingCopy from './MarketingCopy';
import OptionMore from './OptionMore';
import { FamilyFirstIneligibleTrimMessage } from '../../components/mathBox/FamilyFirstIneligibleMessage';

const TrimOption = ({
  option,
  disabled,
  disclaimer,
  analyticsKey,
  onChange
}) => {
  const {
    selected,
    conflict,
    id,
    priceState,
    trimName,
    marketingCopy,
    eligibleForInvoicePrice
  } = option;
  const onSelect = () => {
    if (!disabled && !selected) {
      onChange(option);
    }
  };

  return (
    <div className="option">
      <OptionMsrpHeader
        msrp={option.totalMSRP}
        disclaimer={disclaimer}
        hideLabel={priceState === 'Unknown'}
        analyticsKey={analyticsKey}
        analyticsKey2={id}
      />
      <div className="option__row">
        <div>
          <OptionCheckbox
            id={id}
            checked={selected}
            conflict={conflict}
            disabled={disabled}
            analyticsKey={analyticsKey}
            analyticsKey2={id}
            onChange={onSelect}
          />
        </div>
        <div className="option__column">
          <div
            className="trim-option__content stat-checkbox"
            data-dtm={analyticsKey}
            data-dtm2={trimName}>
            <div
              className={`option__title option__title--small trim-option__title option__selectable ${
                selected ? 'option__selectable--disabled' : ''
              }`}
              onClick={onSelect}>
              {trimName}
            </div>
            <MarketingCopy
              content={marketingCopy}
              className="trim-option__marketing-content"
            />
          </div>
          <FamilyFirstIneligibleTrimMessage
            eligibleForInvoicePrice={eligibleForInvoicePrice}
          />
          <OptionMore
            to={`/trim/features/${id}`}
            analyticsKey={analyticsKey}
            analyticsKey2={trimName}
          />
        </div>
      </div>
    </div>
  );
};

export default TrimOption;
